// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"489":"b75f11e9","561":"b75f11e9","2643":"b75f11e9","9978":"b75f11e9"}[chunkId] + ".chunk.css";
};